var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('div',{staticClass:"inline-flex"},[_c('vx-tooltip',{staticClass:"cursor-pointer mr-5",attrs:{"text":'Edit',"position":"bottom"}},[_c('feather-icon',{attrs:{"icon":"Edit2Icon","svgClasses":`h-4 w-4`},on:{"click":function($event){return _vm.editPromoRequest()}}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }